import { useAppContext } from "../context/AppContext";
import { formatCurrencyAmount } from "../utils/currency.utils";
import css from "./PaymentSummary.module.css";

export default function PaymentSummary() {
  const { orderDetails } = useAppContext();
  const { amount, currency } = orderDetails;
  const formattedAmount = formatCurrencyAmount(amount, currency);

  return (
    <div className={css["payment-summary"]}>
      <div className={css.label}>Amount</div>
      <div className={css.value}>
        {formattedAmount} <span className={css.currency}>{currency}</span>
      </div>
    </div>
  );
}
